module.exports = __webpack_public_path__ + "static/greeting_bg-8f1bcc2b8c3bd20e60ecad25235ac9e4.png";